import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { ButtonBase, makeStyles, Typography } from "@material-ui/core";

import { getBalanceAndSymbol } from "../ethereumFunctions";

import useIcon from "../hooks/useIcon";

const useStyles = makeStyles((theme) => ({
  button: {
    width: "100%",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "&:hover, &$focusVisible": {
      backgroundColor: theme.palette.background.default,
    },
  },
  coinBox: {
    display: "flex",
    flexFlow: "column",
    alignItems: "self-start",
    justifyContent: "flex-start",
    flexGrow: "1",
    marginLeft: theme.spacing(1),
  },
  coinImageNegative: {
    marginLeft: `-${theme.spacing(1)}px`,
  },
  coinName: {
    color: theme.palette.grey[400],
    lineHeight: 1,
    fontSize: "12px",
  },
}));

CoinButton.propTypes = {
  coin: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default function CoinButton({
  onClick,
  coin,
  coins,
  account,
  weth,
}) {
  const classes = useStyles();
  const [iconImage] = useIcon();

  const [balance, setBalance] = useState(0.0);

  useEffect(() => {
    getBalanceAndSymbol(
      account,
      coin.address,
      weth,
      coins
    ).then((data) => {
      setBalance(data.balance);
    });
  }, []);

  return (
    <ButtonBase
      focusRipple
      className={classes.button}
      onClick={() =>
        onClick(
          coin.address,
          !coin.lptokens
            ? coin.abbr || coin.symbol
            : [coin.lptokens.token0.symbol, coin.lptokens.token1.symbol]
        )
      }
    >
      {/* if type of coin is token | else type of coin is lptoken */}
      {!coin.lptokens ? (
        // type of coin in token
        <>
          <img
            src={iconImage(coin.abbr || coin.symbol)}
            alt={coin.abbr || coin.symbol}
            className={classes.coinImage}
          />
          <div className={classes.coinBox}>
            <Typography variant="body1" className="lh-1">
              {coin.name}
            </Typography>
            <Typography variant="body2" className={classes.coinName}>
              {coin.abbr || coin.symbol}
            </Typography>
          </div>

          <span>
            {Number(balance)
              .toFixed(3)
              .replace(/\.?0+$/, "")}
          </span>
        </>
      ) : (
        // type of coin in lptoken
        <div className="w-100 d-flex flex-column align-items-start">
          <div className="d-flex align-items-center">
            <img
              src={iconImage(coin.lptokens.token0.symbol)}
              alt={coin.lptokens.token0.symbol}
              className={classes.coinImage}
            />
            <img
              src={iconImage(coin.lptokens.token1.symbol)}
              alt={coin.lptokens.token1.symbol}
              className={classes.coinImageNegative}
            />

            <div className={classes.coinBox}>
              <Typography variant="body1" className="lh-1">
                {coin.lptokens.token0.name} - {coin.lptokens.token1.name}
              </Typography>
              <Typography variant="body2" className={classes.coinName}>
                {coin.lptokens.token0.symbol} - {coin.lptokens.token1.symbol}
              </Typography>
            </div>
          </div>

          <div className="mt-1">Balance : {balance || "0.00"}</div>
        </div>
      )}
    </ButtonBase>
  );
}
